
import React, { createContext, useContext } from "react";
import { User, Session } from "@supabase/supabase-js";

// Define the shape of our auth context
export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  signOut: () => Promise<void>;
  isAdmin: boolean;
  isSalesAssistant: boolean;
  checkIsAdmin: () => Promise<boolean>;
  checkIsSalesAssistant: () => Promise<boolean>;
  assignedBases: string[];
  refreshAssignedBases: () => Promise<void>;
}

// Create the context with a default undefined value
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Export the useAuth hook with proper error handling
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

// Re-export the AuthProvider from its implementation file
export { AuthProvider } from './auth/AuthProvider';
